<template>
  <v-dialog v-model="dialog" max-width="700" scrollable>
      <v-card width="100%">
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 v-if="complain.type == 'new'" style="color:white">Nieuwe klacht toevoegen</h2>
          <h2 v-else style="color:white">Klacht van {{ complain.firstName }} {{ complain.lastName }}</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="removeClientcomplain(complain.id)" v-if="complain.type == 'view' && (userRole == 'admin' ||  userRole == 'superadmin' )" >
            <v-icon dark color="white">mdi-delete</v-icon>
          </v-btn>

          
          <v-btn icon dark @click="closeComplainDialog()" :disabled="complain.uploading">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

 
          <v-alert
            v-if="complain.feedback"
            class="ma-0 pa-2"
            :value="true"
            type="warning"
            style="border-radius: 0!important"
            v-html="complain.feedback"
          ></v-alert>


        <v-divider></v-divider>

        <v-card-text class="pt-2">
          <div v-if="type =='add' && !client">
            <h3>Zoek klant in Salonhub</h3>
            <v-text-field
              dense
              outlined
              :color="companyPrimaryColor"
              :background-color="$vuetify.theme.themes[theme].background"    
              style="width: 100%;"
              hide-details
              autocomplete="disabled"
              placeholder="naam/email/telefoon"
              label="Vind een klant"
              prepend-inner-icon="search"
              :append-inner-icon="loaderSearch ? 'fas fa-circle-notch fa-spin' : ''"
              v-model="zoekSalonhubClient"
              clearable
              :readonly="type == 'view'"
            ></v-text-field>

            <div v-if="zoekSalonhubClient && zoekSalonhubClient.length > 2" class="searchResults">
              <v-card
                style="position: absolute; width: 100%; z-index:99; max-height: 260px; overflow-y: scroll;"
                class="mx-auto"
                tile
                >
                <v-list v-for="(resultsSearch, index) in searchResultsSalonhub" :key="index"  two-line subtitle dense class="pa-0 ma-0">
                  <v-list-item @click="setClientData(resultsSearch), searchResultsSalonhub = [], zoekSalonhubClient = ''">
                    <v-list-item-avatar >
                      <v-icon class="my-0" style="background-color: #eee;">person</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ resultsSearch.firstname }} {{ resultsSearch.middlename }} {{ resultsSearch.lastname }}</v-list-item-title>
                      <v-list-item-subtitle>{{resultsSearch.address}} <span style="color: rgba(0,0,0,0.54);" v-if="resultsSearch.address">{{resultsSearch.number}}, </span>{{resultsSearch.city}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="index + 1 < searchResultsSalonhub.length"></v-divider> 
                </v-list>

              </v-card>
            </div>
          </div>
          

          <v-container grid-list-sm class="ma-0 pa-0 py-2" fluid>
            <h3 class="pt-2">Algemeen</h3>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-text-field
                  label="Voornaam"
                  v-model="complain.firstName"
                  :rules="requiredRules"
                  dense
                  outlined
                  required
                  hide-details
                  :disabled="type == 'view' || client"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  label="Achternaam"
                  v-model="complain.lastName"
                  :rules="requiredRules"
                  dense
                  outlined
                  required
                  hide-details
                  :disabled="type == 'view' || client"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  class="mt-4"
                  :items="branches"
                  :color="companyPrimaryColor"
                  :item-color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"    
                  item-text="branchName"
                  item-value="id"
                  v-model="complain.branch"
                  no-data-text="Geen vestigingen gevonden."
                  label="Vestiging"
                  hide-details
                  outlined
                  :readonly="type == 'view'"
                  dense>
                </v-select>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  class="mt-4"
                  label="Ingezet door"
                  v-model="complain.employee"
                  :rules="requiredRules"
                  dense
                  outlined
                  required
                  :readonly="type == 'view'"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  class="mt-4"
                  label="Op controle bij"
                  v-model="complain.controlEmployee"
                  :rules="requiredRules"
                  dense
                  outlined
                  required
                  hide-details
                  :readonly="type == 'view'"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-menu     
                  ref="dateDialog"
                  :close-on-content-click="false"
                  v-model="complainDateDialog"
                  transition="scale-transition"
                  max-width="290px"
                  min-width="290px"
                  >
                  <template v-slot:activator="{on}">
                    <v-text-field
                      class="mt-4"
                      :color="companyPrimaryColor"
                      v-on="on"
                      outlined
                      dense
                      v-model="complainDateFormatted"
                      label="Datum klacht"
                      append-icon="today"
                      readonly
                      hide-details
                      :readonly="type == 'view'"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :color="companyPrimaryColor"
                    v-model="complain.date"
                    :max="today"
                    :show-current="true"
                    no-title
                    @input="complainDateDialog = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container grid-list-sm class="ma-0 pa-0 py-2" fluid>
            <h3 class="pt-2">Extra</h3>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-text-field
                  class="mt-4"
                  label="Aantal stuks"
                  v-model="complain.number"
                  :rules="requiredRules"
                  dense
                  outlined
                  required
                  :readonly="type == 'view'"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  class="mt-4"
                  label="Kleur"
                  v-model="complain.color"
                  :rules="requiredRules"
                  dense
                  outlined
                  required
                  :readonly="type == 'view'"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  class="mt-4"
                  :items="lengthOptions"
                  :color="companyPrimaryColor"
                  :item-color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"    
                  item-text="name"
                  item-value="id"
                  v-model="complain.extensionLength"
                  no-data-text="Geen lengtes gevonden."
                  label="Lengte"
                  hide-details
                  :readonly="type == 'view'"
                  outlined
                  dense>
                </v-select>
              </v-flex>
              
              <v-flex md6 xs12>
                <v-switch
                  v-model="complain.pillarrrPhotos"
                  inset
                  label="Foto's in Pillarrr"
                  hide-details
                  :readonly="type == 'view'"
                ></v-switch>
              </v-flex>
              <v-flex md6 xs12>
                <v-switch
                  v-model="complain.medicalIntake"
                  inset
                  label="Medische vragenlijst"
                  hide-details
                  :readonly="type == 'view'"
                ></v-switch>
              </v-flex>
              <v-flex md6 xs12>
                <v-switch
                  v-model="complain.warrant"
                  inset
                  label="Garantiepakket"
                  hide-details
                  :readonly="type == 'view'"
                ></v-switch>
              </v-flex>
              <v-flex md6 xs12>
                <v-switch
                  v-model="complain.deviationForm"
                  inset
                  label="Afwijkingsformulier"
                  hide-details
                  :readonly="type == 'view'"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container grid-list-sm class="ma-0 pa-0 py-2" fluid>
            <h3 class="pt-2">Klacht</h3>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  class="mt-4"
                  :items="complainOptions"
                  :color="companyPrimaryColor"
                  :item-color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"    
                  item-text="name"
                  item-value="id"
                  multiple
                  v-model="complain.complain"
                  no-data-text="Geen klachten gevonden."
                  label="Wat is de klacht?"
                  hide-details
                  outlined
                  :readonly="type == 'view'"
                  dense>
                </v-select>
              </v-flex>
              <v-flex xs12>
                <h3 class="pt-4">De klant voelt zich voor de controle behandeling (zelf inschatten)</h3>
                <p>0 zeer ontevreden - 10 tevreden</p>
                <v-slider
                  class="pt-5"
                  max="10"
                  step="1"
                  v-model.number="complain.emotion"
                  :label="`${complain.emotion}`"
                  thumb-label="always"
                  :thumb-color="companySecondaryColor"
                  :readonly="type == 'view'"
                ></v-slider>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  class="mt-4"
                  label="Omschrijf de klacht in detail"
                  v-model="complain.complainDetail"
                  :rules="requiredRules"
                  dense
                  rows="3"
                  outlined
                  required
                  :readonly="type == 'view'"
                  hide-details
                ></v-textarea>
              </v-flex>
              <v-flex md6 xs12>
                <v-switch
                  v-model="complain.pillarrrPhotosBefore"
                  inset
                  label="Voor foto’s gemaakt in Pilarr"
                  :readonly="type == 'view'"
                  hide-details
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container grid-list-sm class="ma-0 pa-0 py-2" fluid>
            <h2 class="pt-2">Oplossing</h2>
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea
                  class="mt-4"
                  label="Omschrijf de oplossing in detail"
                  v-model="complain.solutionDetail"
                  :rules="requiredRules"
                  dense
                  rows="3"
                  outlined
                  required
                  :readonly="type == 'view'"
                  hide-details
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  class="mt-4"
                  label="Meegekeken/ overlegd met"
                  v-model="complain.lookedAlong"
                  :rules="requiredRules"
                  dense
                  outlined
                  required
                  hide-details
                  :readonly="type == 'view'"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-switch
                  v-model="complain.pillarrrPhotos"
                  inset
                  label="Na foto’s in Pilarr ja/ nee"
                  hide-details
                  :readonly="type == 'view'"
                ></v-switch>
              </v-flex>
              <v-flex md6 xs12>
                <v-switch
                  v-model="complain.productGiven"
                  inset
                  label="Product meegegeven"
                  hide-details
                  :readonly="type == 'view'"
                ></v-switch>
              </v-flex>
              <v-flex xs12 v-if="complain.productGiven">
                <v-text-field
                  class="mt-4"
                  label="Welk product"
                  v-model="complain.productName"
                  :rules="requiredRules"
                  dense
                  outlined
                  required
                  hide-details
                  :readonly="type == 'view'"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-switch
                  v-model="complain.salonhubNotesAdded"
                  inset
                  label="Notities Salonhub bijgewerkt"
                  hide-details
                  :readonly="type == 'view'"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <h3 class="pt-4">De klant voelt zich na de controle behandeling (zelf inschatten)</h3>
                <p>0 zeer ontevreden - 10 tevreden</p>
                <v-slider
                  class="pt-5"
                  max="10"
                  step="1"
                  v-model.number="complain.emotionAfter"
                  :label="`${complain.emotionAfter}`"
                  thumb-label="always"
                  :thumb-color="companySecondaryColor"
                  :readonly="type == 'view'"
                ></v-slider>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  class="mt-4"
                  label="Overige opmerkingen	"
                  v-model="complain.notes"
                  dense
                  rows="3"
                  outlined
                  required
                  :readonly="type == 'view'"
                  hide-details
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider v-if="type == 'add'"></v-divider>

        <v-card-actions v-if="type == 'add'">
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  :disabled="uploading"
                  color="#8B93A6"
                  @click="closeComplainDialog()"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  v-if="type == 'add'" 
                  rounded
                  :loading="uploading"
                  :disabled="uploading"
                  :dark="!uploading"
                  :color="companySecondaryColor"
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  @click="addClientcomplain()"
                  >
                  Toevoegen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
</template>


<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/app";;
import axios from "axios";
import platform from 'platform'; 
import moment from 'moment';
import vueSignature from "vue-signature"
import { P } from "vue-tabs-component";


export default {
  name: "add-intake-form",
  props: ['activeCompData'],
  props:{
    activeCompData: Object,
    branches: Array
  },
  components: {
    vueSignature
  },
  data() {
    return {
      client: false,
      uploading: false,
      complain: {
        type: null,
        dialog: false,
        feedback: null,
        branch: null,
        firstName: null,
        lastName: null,
        employee: null,
        controlEmployee: null,
        emotion: 1,
        complain: null,
        color: null,
        number: null,
        length: null,
        deviationForm:false,
        warrant:false,
        medicalIntake:false,
        pillarrrPhotos:false,
        uploading: false,
        date: moment().format("YYYY-MM-DD"),
        pillarrrPhotosBefore: false,
        pillarrrPhotosAfter: false,
        complainDetail: null,
        solutionDetail: null,
        lookedAlong: null,
        productGiven: false,
        productName: null,
        salonhubNotesAdded: false,
        emotionAfter: 0,
        notes: null
      },
      type: "add",
      
      complainOptions: [
        {
          id: "itch",
          name: "Jeuk"
        },
        {
          id: "wrongPlacement",
          name: "Verkeerde plaatsing"
        },
        {
          id: "qualityHair",
          name: "Kwaliteit haar"
        },
        {
          id: "tangles",
          name: "Klitten"
        },
        {
          id: "tuftLoss",
          name: "Plukverlies"
        },
        {
          id: "cut",
          name: "Snijden"
        },
        {
          id: "visibility",
          name: "Zichtbaarheid"
        },
        {
          id: "discoloration",
          name: "Verkleuring"
        },
        {
          id: "Other",
          name: "Overig"
        },
      ],
      lengthOptions: [
        {
          id: "3540",
          name: "35/40cm"
        },
        {
          id: "5560",
          name: "55/60cm"
        }
      ],
      complainDateDialog: false,


      selectedFromDossier: false,
      valid: false,
      step: 1,
      loaderSearch: false,
      zoekSalonhubClient: null,


      signatureOptions: {
        backgroundColor: '#eeeeee',
      },
      queueEndDateDialog: false,
      requiredRules: [v => !!v || "Dit veld is verplicht"],

      today: null,
      emailRules: [
        v => !!v || "E-mail is verplicht",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
      ],
      feedback: null,
      dialog: false,
      uploading: false,
      uploadProgress: 0,
      searchResultsSalonhub: new Array(),
      idFile: null,
      cardFile: null,
      idFilename: null,
      cardFilename: null,
      idImage: null,
      cardImage: null
    };
  },

  created(){
    bus.$on("openComplainDialog", (client, type, item) =>{
      if(client){
        this.complain.salonhubId = Number(client.id);
        this.complain.firstName = client.firstname;
        this.complain.lastName = client.middlename + " " + client.lastname;
        this.client = true;
      }
      else{
        this.client = false;
      }

      this.type = type ? type : "add";

      if(type && type == "view" && item){
        this.complain = _.cloneDeep(item);
      }

      this.dialog = true;
    });
  },

  methods: {
    closeComplainDialog() {
      this.dialog = false;
      this.complain.dialog = false;
      this.complain.type = "new";
      this.complain.firstName = null;
      this.complain.lastName = null;
      this.complain.branch = null;
      this.complain.employee = null;
      this.complain.controlEmployee = null;
      this.complain.id = null;
      this.complain.date = null;
      this.complain.feedback = null;
      this.complain.complain = null;
      this.complain.complainDetail = null;
      this.complain.color = null;
      this.complain.number = null;
      this.complain.extensionLength = false;
      this.complain.deviationForm = false;
      this.complain.warrant = false;
      this.complain.medicalIntake = false;
      this.complain.emotion = 1;
      this.complain.pillarrrPhotos = false;
      this.complain.pillarrrPhotosBefore = false;
      this.complain.pillarrrPhotosAfter = false;
      this.complain.solutionDetail = null;
      this.complain.lookedAlong = null;
      this.complain.productGiven = false;
      this.complain.productName = null;
      this.complain.salonhubNotesAdded = false;
      this.complain.emotionAfter = 0;
      this.complain.notes = null;
    },

    addClientcomplain(){
      if(this.complain.firstName &&
      this.complain.lastName &&
      this.complain.branch &&
      this.complain.employee &&
      this.complain.controlEmployee &&
      this.complain.complain &&
      this.complain.color &&
      this.complain.number &&
      this.complain.extensionLength &&
      this.complain.solutionDetail && 
      this.complain.complainDetail &&
      this.complain.lookedAlong){
        this.uploading = true;
        db.collection("complains").add({
          companyId: this.activeCompData.id,
          firstName: this.complain.firstName,
          lastName: this.complain.lastName,
          branch: this.complain.branch,
          salonhubId: this.complain.salonhubId ? +this.complain.salonhubId : null,
          dateAdded: new Date(),
          employee: this.complain.employee,
          controlEmployee: this.complain.controlEmployee,
          date: this.complain.date,
          complain: this.complain.complain,
          complainDetail: this.complain.complainDetail,
          color: this.complain.color,
          number: this.complain.number,
          extensionLength: this.complain.extensionLength,
          deviationForm: this.complain.deviationForm,
          warrant: this.complain.warrant,
          medicalIntake: this.complain.medicalIntake,
          emotion: this.complain.emotion,
          pillarrrPhotos: this.complain.pillarrrPhotos,
          pillarrrPhotosBefore: this.complain.pillarrrPhotosBefore,
          pillarrrPhotosAfter: this.complain.pillarrrPhotosAfter,
          solutionDetail: this.complain.solutionDetail,
          lookedAlong: this.complain.lookedAlong,
          productGiven: this.complain.productGiven,
          productName: this.complain.productName,
          salonhubNotesAdded : this.complain.salonhubNotesAdded,
          emotionAfter: this.complain.emotionAfter,
          notes: this.complain.notes
        })
        .then(()=>{
          this.uploading = false;
          this.closeComplainDialog();
          this.$emit("updateData");
        })
      }
      else{
        if(!this.complain.firstName || !this.complain.lastName){
          this.complain.feedback = "Vul de naam van de klant in.";
        }
        else if(!this.complain.branch){
          this.complain.feedback = "Selecteer de vestiging";
        }
        else if(!this.complain.employee || !this.complain.controlEmployee){
          this.complain.feedback = "Vul de namen van de medewerkers in.";
        }
        else if(!this.complain.extensionLength || !this.complain.number || !this.complain.color ){
          this.complain.feedback = "Vul het aantal, kleur en lengte van de extensions in";
        }
        else if(!this.complain.complain){
          this.complain.feedback = "Selecteer de klacht van de klant.";
        }
      }
    },

    setClientData(resultsSearch){
      this.complain.firstName = resultsSearch.firstname;
      this.complain.lastName = resultsSearch.middlename + " " + resultsSearch.lastname;
      this.complain.salonhubId = resultsSearch.id;
    },

    getClientDataById(id){
      const urlCustomerId = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/getCustomer?id=${encodeURI(id)}`
      fetch(urlCustomerId)
      .then(response => response.json())
      .then(data => {
        if(data){
          this.complain.firstName = data.firstname;
          this.complain.lastName = data.middlename + " " + data.lastname;
          this.complain.street = data.address + " " + data.number;
          this.complain.zipcode = data.postalcode;
          this.complain.city = data.city;
          this.complain.salonhubId = +data.id;
        }
      })
    },

    async saveMedicalIntake(){
      this.uploading = true;
      let fileUrls = {
        signatureUrl: null,
      };

      await new Promise((resolve, reject)=>{
        let counter = 0;
        let files = new Array();

        files = [
          {
            id: 'signature', 
            fileVar: 'signatureUrl', 
            field: 'clientSignature',
            url: this.activeCompData.id + "/" + "sign/" + this.activeCompData.id + "-" + moment().format("X")+ "intake-sign.png"
          },
        ];

        files.forEach(file => {
          let uploadTask = firebase.storage().ref(file.url).putString(this.complain[file.field].split(",")[1], "base64" );

          uploadTask.on(
            "state_changed",
            taskSnapshot => {},
            error => {
              console.log(error);
            }, () => {
              console.log("The upload is compleet:", file.id);
              uploadTask.snapshot.ref
              .getDownloadURL()
              .then(url => {
                fileUrls[file.fileVar] = url;
                counter++
                if(counter == files.length){
                  resolve()
                }
              })
              .catch(error => {
                reject(error)
              });
            }
          );
        });
      })
      
      db.collection("intakes").add({
        companyId: this.activeCompData.id,
        firstName: this.complain.firstName,
        lastName: this.complain.lastName,
        branch: this.complain.branch,
        salonhubId: this.complain.salonhubId ? +this.complain.salonhubId : null,
        dateAdded: new Date(),
        signDate: this.complain.signDate,
        clientSignature: fileUrls.signatureUrl,
        agreeTermsAndConditions: this.complain.agreeTermsAndConditions,
        questions: {
          colorTimesYear: this.complain.questions.colorTimesYear,
          bleachedLastYear: this.complain.questions.bleachedLastYear,
          recentWeightloss: this.complain.questions.recentWeightloss,
          stress: this.complain.questions.stress,
          medicines: this.complain.questions.medicines,
          medicinHairloss: this.complain.questions.medicinHairloss,
          narcose: this.complain.questions.narcose,
          hormoneFluctuations: this.complain.questions.hormoneFluctuations,
          recentBirth: this.complain.questions.recentBirth,
          periodGiveBirth: this.complain.questions.periodGiveBirth,
          boldness: this.complain.questions.boldness,
          diseases: this.complain.questions.diseases,
          corona: this.complain.questions.corona,
          age: this.complain.questions.age,
          vega: this.complain.questions.vega,
        },
        analyse:{
          porousHair: this.complain.analyse.porousHair,
          hairThickness: this.complain.analyse.hairThickness,
          porousHair: this.complain.analyse.porousHair,
          wearingTime: this.complain.analyse.wearingTime,
          brand: this.complain.analyse.brand,
          length: this.complain.analyse.length,
          numberExtensions: this.complain.analyse.numberExtensions,
          wearingType: this.complain.analyse.wearingType
        },
        feedback: {
          questions: this.complain.feedback.questions,
          analyse: this.complain.feedback.analyse,
        }
      })
      .then(()=>{
        this.uploading = false;
        this.closeAddMedicalIntakeDialog();
        this.$emit("updateData");
      })
      .catch(err => {
        this.feedback = "Fout bij opslaan. Probeer het opnieuw."
        console.error("Error adding document to membership", err);
      });
    },

    formatDate(date) {
      // Datum omvormen naar Europese leesbare datum
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    }
  },

  

   watch: {
    zoekSalonhubClient() {
      const url = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/searchCustomer?salon=*&query=${encodeURI(this.zoekSalonhubClient)}`
      const urlCustomerId = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/getCustomer?id=${encodeURI(this.zoekSalonhubClient)}`
    
      return new Promise(resolve => {
        let counter = 0;
        if (!this.zoekSalonhubClient || (this.zoekSalonhubClient && this.zoekSalonhubClient.length < 3)) {
          this.searchResultsSalonhub = [];
          return resolve([])
        } 
        else {
          this.searchResultsSalonhub = [];
          this.loaderSearch = true;
          fetch(url)
          .then(response => response.json())
          .then(data => {
            counter++
            if(counter == 2){
              resolve()
            }
            this.searchResultsSalonhub = data.slice(0,15)
          })
          fetch(urlCustomerId)
          .then(response => response.json())
          .then(data => {
            if(data){
              this.searchResultsSalonhub.unshift(data);
            }
            counter++
            if(counter == 2){
              resolve()
            }
          })
        } 
      })
      .then(()=>{
        this.loaderSearch = false
      })
    },
  },

  computed: {

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
     theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    complainDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.complain.date);
    },
      
  }
};
</script>
<style>
.v-overlay__scrim,
.v-overlay.v-overlay--active{
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}


.medical-question-collapse{
  position: relative;
  padding: 0 15px 0 0;
  font-weight: bold;
}

.medical-question-collapse:after{
  display: block;
  content: "";
  position: absolute;
  right: 0;
  top: 3px;
  width: 15px;
  height: 15px;
  border: 7px solid black;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.medical-question-collapsed-wrapper{
  display: none;
}
.medical-question-collapse:hover .medical-question-collapsed-wrapper,
.medical-question-collapse:focus .medical-question-collapsed-wrapper{
  display: block;
  position: absolute;
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  display: block;
  width: 350px;
  box-shadow: 0px 0px 25px #999;
}


.medical-question-item{
  display: block;
  width: 100%;
  border-bottom: 1px solid #eee;
  padding: 3px 5px;
}

</style>
